var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutwardInsights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 39,
    viewBox: "0 0 46 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.47191 2.28593C3.47191 1.57573 2.91855 1 2.23596 1C1.55336 1 1 1.57573 1 2.28593V30.7141C1 31.4243 1.55336 32 2.23596 32H10.764C11.4466 32 12 31.4243 12 30.7141C12 30.0039 11.4466 29.4281 10.764 29.4281H3.47191V2.28593Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.62262C6 6.07033 6.44772 5.62262 7 5.62262H12.0588C12.6111 5.62262 13.0588 6.07034 13.0588 6.62262L13.0588 25C13.0588 25.5523 12.6111 26 12.0588 26H7C6.44772 26 6 25.5523 6 25L6 6.62262Z",
    fill: "#4D84F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4706 11.8648C14.4706 11.3125 14.9183 10.8648 15.4706 10.8648H20.5294C21.0817 10.8648 21.5294 11.3125 21.5294 11.8648V25C21.5294 25.5523 21.0817 26 20.5294 26H15.4706C14.9183 26 14.4706 25.5523 14.4706 25V11.8648Z",
    fill: "#E7332F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9412 4C22.9412 3.44772 23.3889 3 23.9412 3H29C29.5523 3 30 3.44772 30 4V25C30 25.5523 29.5523 26 29 26H23.9412C23.3889 26 22.9412 25.5523 22.9412 25V4Z",
    fill: "#009D00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4805 17.8994C30.5274 17.3706 29.3624 17.3999 28.4375 17.9766L16.4121 25.4766C15.5336 26.0245 15 26.9871 15 28.0225C15 29.0578 15.5336 30.0204 16.4121 30.5684L28.4375 38.0684C29.3624 38.645 30.5274 38.6743 31.4805 38.1455C32.4336 37.6166 33.0254 36.6125 33.0254 35.5225V34.1543H43C44.6568 34.1543 45.9999 32.811 46 31.1543V24.8906C45.9999 23.2339 44.6568 21.8906 43 21.8906H33.0254V20.5225C33.0254 19.4324 32.4336 18.4283 31.4805 17.8994Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43 25.4909C43 25.1595 42.7314 24.8909 42.4 24.8909H30.6249C30.2936 24.8909 30.0249 24.6223 30.0249 24.2909V21.6038C30.0249 21.1328 29.5071 20.8455 29.1074 21.0947L18.8162 27.5134C18.4396 27.7483 18.4396 28.2966 18.8162 28.5316L29.1074 34.9502C29.5071 35.1995 30.0249 34.9121 30.0249 34.4411V31.754C30.0249 31.4227 30.2936 31.154 30.6249 31.154H42.4C42.7314 31.154 43 30.8854 43 30.554V25.4909Z",
    fill: "#EDBA25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutwardInsights);
export default __webpack_public_path__ + "static/media/OutwardInsights.4796c6b1270c335f73d4547c8dbb8245.svg";
export { ForwardRef as ReactComponent };